import ScoreChartWithKey from './ScoreChartWithKey'

export default ScoreChartWithKey
